import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const eventsRoute: RouteConfig = {
  path: 'event',
  name: 'eventList',
  component: () => import(/* webpackChunkName: "EventList" */ '@/views/mainRoute/event/List.vue'),
  meta: {
    breadcrumb: {
      title: 'Zdarzenia',
      name: 'eventList'
    },
    config: {
      title: 'Zdarzenia',
      name: 'eventList',
      icon: 'fa-calendar',
      permissions: ['EVENT.LIST'],
      group: 'Konfiguracja wzorów'
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('event/list')
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.EVENT_CANNOT_LIST }));
  }
};
